<div class="tp-scroll-wrapper">
  <div
    class="tp-scroll-container"
    #scrollEl
    [style.height.px]="containerHeight"
    (scroll)="onScroll()"
    (touchstart)="onTouchStart($event)"
    (touchmove)="onTouchMove($event)"
    (touchend)="onTouchEnd()"
  >
    <div class="tp-spacer" [style.height.px]="paddingSize"></div>

    <div
      class="tp-item"
      *ngFor="let item of items; let i = index"
      [style.height.px]="config.itemHeight"
      [style.opacity]="getItemOpacity(i)"
      [style.font-size]="getItemFontSize(i)"
      [style.font-weight]="getItemFontWeight(i)"
      (click)="selectItem(i)"
    >
      {{ item }}
    </div>

    <div class="tp-spacer" [style.height.px]="paddingSize"></div>
  </div>
</div>
